<template>
    <div class="border-b border-theme-border">
        <div class="flex flex-wrap">
            <div class="w-full flex flex-col justify-around py-3 px-1">
                <div class="flex justify-between">
                    <span class="text-theme-primary capitalize p-0">
                        {{ `${user.firstName} ${user.lastName}` }}
                    </span>
                    <div class="flex">
                        <app-button icon circle @click="onClick">
                            ✔️
                        </app-button>
                        <button
                            v-show="slug"
                            icon
                            circle
                            class="btn-a"
                            @click="goToMainPage(slug)"
                        >
                            🖊
                        </button>
                    </div>
                </div>

                <div class="flex flex-col md:flex-row md:justify-between">
                    <div class="flex md:flex-col justify-between mr-1">
                        <strong class="text-theme-primary"
                            >Indentificación
                        </strong>
                        <div class="flex items-center">
                            <small class="text-uppercase">
                                {{
                                    `${user.identificationType} ${user.identificationNumber}`
                                }}
                            </small>
                        </div>
                    </div>
                    <div class="flex md:flex-col justify-between mr-1">
                        <strong class="text-theme-primary">Correo </strong>
                        <small>
                            {{ user.email }}
                        </small>
                    </div>
                    <div class="flex md:flex-col justify-between mr-1">
                        <strong class="text-theme-primary">Celular </strong>
                        <small>
                            {{ user.phone }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserTableItems",
    props: {
        user: {
            type: Object,
            required: true,
            default: () => ({
                id: 9,
                email: "Cargando...",
                firstName: "Cargando...",
                identificationNumber: "Cargando...",
                identificationType: "cc",
                lastName: "Zamora",
                neighborhood: "Cargando...",
                phone: "Cargando..."
            })
        },
        slug: {
            type: String,
            default: () => "",
            required: false
        }
    },
    emits: ["click"],
    methods: {
        goToMainPage(slug) {
            window.open(`${slug}`, "_blank").focus();
        },
        onClick() {
            this.$emit("click", this.user);
        }
    }
};
</script>
